import * as actions from '../Actions/Controls';

export const controlsReducer = (state = {}, action) => {
    switch (action.type) {
        case actions.GET_CONTROLS_DATA_REQUESTED:
            return {...state, isLoading: true};
        case actions.GET_PLANNED_CONTROLS_DATA_REQUESTED:
            return {...state, isPlannedControlsLoading: true};
        case actions.GET_ACTIVE_CONTROLS_DATA_REQUESTED:
            return {...state, isActiveControlsLoading: true};
        case actions.GET_DONE_CONTROLS_DATA_REQUESTED:
            return {...state, isDoneControlsLoading: true};
        case actions.GET_MANAGE_DONE_CONTROLS_DATA_REQUESTED:
            return {...state, isManageDoneControlsLoading: true};
        case actions.GET_MANAGE_PLANNED_CONTROLS_DATA_REQUESTED:
            return {...state, isManagePlannedControlsLoading: true};
        case actions.GET_MANAGE_ACTIVE_CONTROLS_DATA_REQUESTED:
            return {...state, isManageActiveControlsLoading: true};
        case actions.GET_CONTROLS_DATA_DONE:
            return {...state, isLoading: false, controls: action.payload.content ? action.payload.content : action.payload, filters: action.payload};
        case actions.GET_PLANNED_CONTROLS_DATA_DONE:
            return {...state, isPlannedControlsLoading: false, plannedControls: action.payload.content ? action.payload.content : action.payload, filters: action.payload};
        case actions.GET_ACTIVE_CONTROLS_DATA_DONE:
            return {...state, isActiveControlsLoading: false, activeControls: action.payload.content ? action.payload.content : action.payload, filters: action.payload};
        case actions.GET_DONE_CONTROLS_DATA_DONE:
            return {...state, isDoneControlsLoading: false, doneControls: action.payload.content ? action.payload.content : action.payload, filters: action.payload};
        case actions.GET_MANAGE_PLANNED_CONTROLS_DATA_DONE:
            return {...state, isManagePlannedControlsLoading: false, managePlannedControls: action.payload.content ? action.payload.content : action.payload, filters: action.payload};
        case actions.GET_MANAGE_ACTIVE_CONTROLS_DATA_DONE:
            return {...state, isManageActiveControlsLoading: false, manageActiveControls: action.payload.content ? action.payload.content : action.payload, filters: action.payload};
        case actions.GET_MANAGE_DONE_CONTROLS_DATA_DONE:
            return {...state, isManageDoneControlsLoading: false, manageDoneControls: action.payload.content ? action.payload.content : action.payload, filters: action.payload};
        case actions.GET_CONTROLS_DATA_FAILED:
            return {...state, isLoading: false, isError: true, error: action.payload};
        case actions.SET_FILTERS_DATA:
            return {...state, tableFilters: action?.payload?.filter?.length ? [...action?.payload?.filter] : [], tableName: action.payload.tableName};
        case actions.SET_QUICK_SEARCH_DATA:
            return {...state, tableQuickSearch: action?.payload?.quickSearch, tableName: action.payload.tableName};
        case actions.SET_TAB_DATA:
            return {...state, tableName: action.payload.tableName, tableTab: action.payload.tab, tableFilters: action?.payload?.filter?.length ? [...action?.payload?.filter] : [], tableQuickSearch: action?.payload?.quickSearch};
        default:
            return state;
    }
};
